import { DefaultTheme } from "styled-components";
import { AnimatedRoundedSelectSize } from "../enums/AnimatedRoundedSelectSize";
import { Breakpoint } from "../enums/Breakpoints";

export const wtcTheme: DefaultTheme = {
  button: {
    book: {
      background: "#5A9AFF",
      color: "white",
      disabledBackground: "#C1C1C1",
    },
    primary: {
      background: "#5A9AFF",
      color: "white",
    },
  },
  skeletonLoader: {
    baseColor: "#eff0f2",
    highlightColor: "#f6f6f7",
  },
  footer: {
    dark: {
      background: "#f3f3f3",
      color: "#8f96a3",
      hoverColor: "white",
      titleColor: "black",
    },
    light: { background: "white", color: "#8f96a3" },
  },
  form: {
    calendar: { hover: "#00afef1c", selected: "#00AFEF", range: "#00afef1c" },
    checkbox: { activeColor: "#00AFEF" },
    radio: { activeColor: "#00AFEF" },
    slider: { activeColor: "#00AFEF", color: "#00AFEF" },
    switch: {
      offColor: "#e3e5e8",
      onColor: "#00AFEF",
    },
    errorColor: "#f44336",
  },
  header: {
    background: "#FFFFFF",
    color: "#000",
    iconColor: "#000",
    logoBackground: "#FFFFFF",
    menuHover: "#f9b19b",
  },
  mobileFilters: { background: "#5A9AFF", color: "white" },
  page: {
    srp: {
      background: "#E4E5E9",
      headerBackground: "#4A576F",
    },
  },
  primaryColor: "#5A9AFF",
  progressColor: "#00AFEF",
  timelineColor: "#00339a",
  inputIconColor: "#bdbdbd",
  sugester: {
    hover: "#ebebeb",
    listBackground: "#fff",
  },
  map: {
    marker: {
      color: "#003580",
      hoverColor: "#0071c2",
      selectedColor: "#0071c2",
    },
  },
  redesign: {
    regularFont: `"objektiv mk1", sans-serif`,
    heavyFont: `"objektiv mk1-heavy", sans-serif`,
    sharpBorderRadius: "5px",
    ovalBorderRadius: "5px",
    defaultBackground: "#FFFFFF",
    defaultBoxShadow: "#00000033",
    defaultColor: "#000000",
    defaultLinkColor: "#139bf1",
    primaryColor: "#F36438",
    onPrimaryBgColor: "#FFFFFF",
    confirmationColor: "#009D73",
    errorColor: "#F36438",
    disabledColor: "#BFBFBF",
    darkBackground: "#E3E3E3",
    lightBackground: "#F2F2F2",
    primeLightColor: "#e3e4e5",
    primeDarkColor: "#2e3742",
    flights: {
      searchResultsPage: {
        collapsedSearchFormBackground: "#D3D3D3",
        mainPriceColor: "#FFFFFF",
        referencePriceColor: "#000000",
        header: {},
        singleFlight: {
          availableSeatsColor: "#000000",
          highlightColor: "#F36438",
          discountLabelBackground: "#000000",
          discountLabelColor: "#FFFFFF",
          mobileBookingCostColor: "#000000",
          recommendedTilePillColor: "#FFFFFF",
          fbaIconCheckmarkBackground: "#F36438",
          fbaIconCheckmarkColor: "#FFFFFF",
          freeLounge: {
            backgroundColor: "#C00051",
          },
          titlePillBorderRadius: "5px",
          priceContainerBorderRadius: "3px",
          priceContainerBackground: "#F36438",
          arrowColor: "transparent",
        },
        sortRow: {
          floatingButtons: {
            boxShadowColor: "#00000033",
          },
          quickSort: {
            inactiveColor: "#000000",
            activeColor: "#FFFFFF",
          },
        },
        detailsModal: {
          header: {
            backgroundColor: "#F36438",
            textColor: "#FFFFFF",
            discountTextColor: "#000000",
          },
          alertColor: "#F36438",
          combiDeal: {
            borderColor: "#F36438",
            textColor: "#000000",
          },
          bounds: {
            backgroundColor: "#FFFFFF",
            borderBottomColor: "#000000",
            segmentsBorderColor: "#F36438",
          },
          smallFreeLoungeBanner: {
            dropdownIndicatorBackground: "#F36438 0% 0% no-repeat padding-box",
          },
        },
        pagination: {
          currentPageButtonBackground: "transparent",
          pageButtonHoverBackground: "#f9b19b",
        },
        searchTabs: {
          wrapper: {
            mobileBackground: "transparent",
          },
          tab: {
            background: "#F2F2F2",
          },
          searchButton: {
            background: "#d3d3d3",
            gradient:
              "transparent linear-gradient(270deg, #d3d3d3 0%, #d3d3d300 100%) 0% 0% no-repeat padding-box",
          },
        },
        errorBox: {
          showAllTextColor: "#139bf1",
        },
        sponsoredFlightModal: {
          mobileCloseButtonFont: `"OpenSans", sans-serif`,
        },
        hotelsPromo: {
          backgroundColor: "#F36438",
          discoverLinkColor: "#000000",
          discoverLinkBackground: "#FFFFFF",
          discoverLinkBorderColor: "#000000",
          hotelImage: {
            borderRadius: "5px",
          },
        },
      },
      searchForm: {
        backgroundColor: "#F2F2F2",
        flightTypeSelectedColor: "#F36438",
        flightTypeLabelColor: "#FFFFFF",
        buttonColor: "#139bf1",
        flightTypeRadioTextShadow: "rgba(0, 0, 0, 0.75) 0px 2px 8px",
        flightTypeRadioFontWeight: "700",
        inputFont: `"objektiv mk1", sans-serif`,
        paddingTop: {
          mobile: "44px",
          tablet: "32px",
          desktop: "130px",
        },
      },
    },
    header: {
      linkUnderlineColor: "#F36438",
      backgroundColor: "#FFFFFF",
      backdropColor: "#00000080",
      itemHoverBgColor: "#F6F6F6",
      color: "#000000",
      signInButton: {
        background: "#FFFFFF",
        color: "#000000",
        hoverBackground: "#F6F6F6",
        mobileIconColor: "#11100D",
        borderRadius: "5px",
      },
      signedUserItem: {
        fontWeigthType: "heavy",
      },
      mobileNavigation: {
        itemBorderBottom: "none",
        background: "#F6F6F6",
        fontWeightType: "regular",
        fontSize: "13px",
        verticalItemHeight: "43px",
        verticalItemMargin: "0 25px",
        navContainerPadding: "13px 0px",
      },
      profileDropdown: {
        fontSize: "11px",
        menuItemHoverBg: "#F6F6F6",
      },
      logoColorVariant: "redesign",
      logoHeight: {
        mobile: "30px",
        tablet: "30px",
        desktop: "30px",
      },
    },
    footer: {
      backgroundColor: "#FFFFFF",
      color: "#000000",
      linksSection: {
        backgroundColor: "#F36438",
        color: "#FFFFFF",
      },
      paymentIcons: {
        backgroundColor: "#F2F2F2",
      },
      newsletterButton: {
        backgroundColor: "#139bf1",
      },
      agentPicker: {
        selectedItemColor: "#FFFFFF",
      },
    },
    homePage: {
      flightsTravelSuggestions: {
        destinationTitleColor: "#FFFFFF",
      },
    },
    form: {
      textField: {
        placeholderColor: "#BFBFBF",
        borderRadius: "5px",
      },
      radioGroup: {
        disabled: "#c2c5c7",
        labelColor: "#000000",
        activeButtonColor: "#139bf1",
        inactiveButtonColor: "#000000",
      },
      button: {
        primaryBackground: "#139bf1",
        primaryHoverBackground: "#137cbe",
        defaultHoverBackground: "#f9b19b",
        darkSemiTransparentBackground: "rgb(0,0,0,0.5)",
        darkSemiTransparentColor: "#FFFFFF",
        darkSemiTransparentHoverBackground: "rgb(0,0,0,0.75)",
        darkSemiTransparentHoverColor: "#FFFFFF",
      },
      selectField: {
        backgroundColor: "#FFFFFF",
        defaultOptionsListShadow: "0px 0px 20px #00000033",
        defaultItemHoverBackground: "#f9b19b",
      },
      calendar: {
        hover: "#f9b19b",
        active: "#F36438",
        activeMonthColor: "#FFFFFF",
      },
      dropdown: {
        boxShadow: "#00000033",
      },
      animatedRoundedSelect: {
        borderRadiusPerSize: {
          [AnimatedRoundedSelectSize.ExtraSmall]: "5px",
          [AnimatedRoundedSelectSize.Small]: "5px",
          [AnimatedRoundedSelectSize.Medium]: "5px",
        },
        hoveredOptionBackground: "#f9b19b",
        selectedOptionBackground: "#F36438",
        optionLabelColor: {
          selected: "#000000",
          hover: "#000000",
          default: "#000000",
        },
      },
      switcher: {
        containerBorderRadius: "9px",
        selectionBorderRadius: "9px",
        mobileContainerBorderRadius: "11px",
        mobileSelectionBorderRadius: "8px",
        labelColor: "#000000",
        checkedLabelColor: "#FFFFFF",
      },
      checkbox: {
        selectOnlyColor: "#139bf1",
        useWhiteCheckmark: true,
      },
    },
    tooltip: {
      boxShadow: "0px 0px 20px #00000033",
    },
    mobileModal: {
      backgroundColor: "#F2F2F2",
    },
    hotels: {
      searchResultsPage: {
        referencePriceColor: "#000000",
        singleHotel: {
          showMapButtonColor: "#008eff",
          nearestAirportTextColor: "#009d73",
          priceLoaderColor: "#C3C3C3",
          imageLoaderColor: "#E3E3E3",
          priceContainerBackground: "#F36438",
          arrowColor: "transparent",
        },
        mapModal: {
          closeButton: {
            backgroundColor: "rgba(0, 0, 0, 0.5)",
            hoverBackgroundColor: "rgba(0, 0, 0, 0.75)",
            iconColor: "rgba(255, 255, 255, 1)",
          },
          toggleButton: {
            boxShadow: "0px 0px 25px 0px #00000040",
          },
          hotelListElement: {
            hoverShadow: "0px 0px 10px 0px #00000040",
            mapMarkerShadow: "0px 0px 5px 0px rgba(0, 0, 0, 0.50);",
            borderRadius: "0px",
          },
          mapMarker: {
            noOfferBackground: "#D9D9D9",
            borderRadius: "2px",
          },
        },
        sortRow: {
          floatingButtons: {
            boxShadowColor: "#00000033",
          },
        },
      },
      filters: {
        pills: {
          primaryHoverColor: "#137cbe",
          defaultHoverColor: "#f9b19b",
        },
        autocomplete: {
          field: {
            placeholderColor: "#d9d9d9",
          },
        },
      },
    },
    paymentStep: {
      arrowColor: "transparent",
    },
    breakpoints: {
      maxTheSmallestMobile: Breakpoint.MaxTheSmallestMobile,
      maxSmallMobile: Breakpoint.MaxSmallMobile,
      minMobile: Breakpoint.MinMobile,
      onlyMobile: Breakpoint.OnlyMobile,
      maxMobile: Breakpoint.MaxMobile,
      minTablet: Breakpoint.MinTablet,
      onlyTablet: Breakpoint.OnlyTablet,
      minMidTablet: Breakpoint.MinMidTablet,
      onlyMidTablet: Breakpoint.OnlyMidTablet,
      maxTablet: Breakpoint.MaxTablet,
      minDesktop: Breakpoint.MinDesktop,
      onlyDesktop: Breakpoint.OnlyDesktop,
      maxDesktop: Breakpoint.MaxDesktop,
      minLargeDesktop: Breakpoint.MinLargeDesktop,
      minHugeDesktop: Breakpoint.MinHugeDesktop,
    },
  },
};
